<ng-template #suffixIcon>
  <svg-icon
    src="assets/icons/Arrows/chevron-down.svg"
    class="size-6 hover:text-blue"
    [ngClass]="{ 'rotate-180': select.nzOpen }"
  />
</ng-template>

<ng-template #clearIcon>
  <svg-icon
    src="assets/icons/General/x-circle.svg"
    svgClass="hover:text-blue"
  />
</ng-template>

<ng-template #removeIcon>
  <svg-icon src="assets/icons/General/x-close.svg" class="size-4.25!" />
</ng-template>

<ng-template #menuItemSelectedIcon>
  <svg-icon src="assets/icons/General/check.svg" class="size-6" />
</ng-template>

<ng-template #emptyTemplate>
  @if (!props.isLoading) {
    <div class="my-4 flex items-center gap-4 px-3.5 py-2">
      <svg-icon src="assets/icons/Files/file-question-03.svg" class="" />
      {{ 'forms.select.empty' | translate }}
    </div>
  }
</ng-template>

<ng-template #maxTagPlaceholder>
  {{ props.label }}
</ng-template>

<nz-select
  #select
  class="w-full"
  [attr.data-test-id]="key"
  [nzMaxMultipleCount]="props.maxMultipleCount ?? Infinity"
  [nzShowArrow]="true"
  [nzShowSearch]="true"
  [class.ng-dirty]="showError"
  [nzPlaceHolder]="props.placeholder ?? null"
  [formControl]="formControl"
  [formlyAttributes]="field"
  [nzMode]="props.mode ?? 'default'"
  [nzSize]="props.size ?? 'default'"
  [nzAllowClear]="props.allowClear ?? false"
  [nzDisabled]="props.disabled"
  [nzSuffixIcon]="suffixIcon"
  [nzClearIcon]="clearIcon"
  [nzRemoveIcon]="removeIcon"
  [nzMenuItemSelectedIcon]="menuItemSelectedIcon"
  [nzOptionHeightPx]="40"
  [nzLoading]="props.isLoading ?? false"
  [nzNotFoundContent]="emptyTemplate"
  [nzDropdownMatchSelectWidth]="props.dropdownMatchSelectWidth ?? true"
  [nzMaxTagCount]="props.maxTagCount ?? Infinity"
  [nzMaxTagPlaceholder]="maxTagPlaceholder"
  (nzOpenChange)="props.openChange ? props.openChange(field) : null"
>
  @let options = props.options | localFormlySelectOptions: field | async;

  @if (props.isLoading && !options) {
    <nz-option [nzDisabled]="true" [nzCustomContent]="true">
      <div class="flex items-center gap-4 px-3.5 py-2">
        <svg-icon
          src="assets/icons/General/loading-01.svg"
          class="animate-spin"
        />
        {{ 'forms.select.loading' | translate }}
      </div>
    </nz-option>
  }

  @for (item of options ?? []; track item.value) {
    @if (item.group) {
      <nz-option-group [nzLabel]="item.label">
        @for (child of item.group; track child.value) {
          <ng-container
            [ngTemplateOutlet]="optionItemTemplate"
            [ngTemplateOutletContext]="{ item: item, field: field }"
          />
        }
      </nz-option-group>
    } @else {
      <nz-option
        [nzValue]="item.value"
        [nzLabel]="item.label"
        [nzDisabled]="item.disabled"
        [nzHide]="item.hidden"
        [nzCustomContent]="true"
      >
        <ng-container
          [ngTemplateOutlet]="optionItemTemplate"
          [ngTemplateOutletContext]="{ item: item, field: field }"
        />
      </nz-option>
    }
  }
</nz-select>

<ng-template #optionItemTemplate let-item="item" let-field="field">
  <div
    class="flex items-center gap-3 px-3.5 py-2"
    [attr.data-test-id]="`option-${item.value}`"
    (mouseover)="
      props.optionItemOverCallback
        ? props.optionItemOverCallback(field, item)
        : null
    "
    (focus)="
      props.optionItemOverCallback
        ? props.optionItemOverCallback(field, item)
        : null
    "
  >
    @if (props.mode === 'multiple') {
      <div class="rounded-sm border border-grey-300">
        <svg-icon
          class="block! size-4 shrink-0 text-transparent"
          src="assets/icons/General/check.svg"
        />
      </div>
    }
    <span class="pr-4">
      @if (props.optionItemTemplate) {
        <ng-container
          [ngTemplateOutlet]="props.optionItemTemplate"
          [ngTemplateOutletContext]="{ item: item, field: field }"
        />
      } @else {
        {{ item.label }}
      }
    </span>
  </div>
</ng-template>
